import Sentry from '@/plugins/sentry'

export default {
  install (Vue, options) {
    const { GAId, TypekitId } = options

    // init TypeKit
    this.typekit(TypekitId)
    this.initSciteAi()

    // initialize scripts based on removal of scripts
    Vue.prototype.$scripts = {
      initialize (user) {
        let email = ''
        if (user) {
          email = user.email

          if (user.user_type === 'premium' && user.vitally) {
            this.initVitally(user)
          }
        }

        if (process.env.VUE_APP_DEPLOY_ENV === 'production' && !email.includes('academiclabs')) {
          // init hotjar
          this.hotjar()
          // init google analytics
          this.googleAnalytics(GAId, user)
        }
      },
      hotjar () {
        (function (h, o, t, j, a, r) {
          h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) }
          h._hjSettings = { hjid: 141650, hjsv: 6 }
          a = o.getElementsByTagName('head')[0]
          r = o.createElement('script'); r.async = 1
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
          a.appendChild(r)
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
      },
      googleAnalytics (GAId, user) {
        let url = `https://www.googletagmanager.com/gtag/js?id=${GAId}`

        return new Promise((resolve, reject) => {
          // Load Google Analytics script file
          return this.loadScriptGa(url).then(() => {
            resolve()
          }).catch(() => {
            // let err = '[ga-analytics] It\'s not possible to load Google Analytics script'
            // new Error(err)
          })
        }).then(() => {
          this.onAnalyticsReady()
        }).then(() => {
          return typeof GAId === 'function' ? GAId() : GAId
        }).then(GAId => {
          /* eslint-disable */
          window.dataLayer = window.dataLayer || []
          function gtag () { dataLayer.push(arguments) }
          gtag('js', new Date())
          gtag('config', GAId)
          // Set user ID for Google Analytics
          if (user) {
            gtag('config', GAId, {
              'user_id': user.user_id
            });
          }
        }).catch(() => {
          // let err = `[ga-analytics] It\'s not possible to load Google Analytics script`
          // new Error(`${err}-${error}`)
        })
      },
      loadScriptGa (url) {
        return new Promise((resolve, reject) => {
          var head = document.head || document.getElementsByTagName('head')[0]
          const script = document.createElement('script')
          script.async = true
          script.src = url
          script.type = 'text/javascript'
          script.charset = 'utf8'

          head.appendChild(script)

          script.onload = resolve
          script.onerror = reject
        })
      },
      onAnalyticsReady () {
        return new Promise((resolve, reject) => {
          const poll = setInterval(() => {
            if (typeof window === 'undefined' || !window.ga) {
              return
            }

            resolve()
            clearInterval(poll)
          }, 10)
        })
      },
      initVitally (user) {
        return new Promise((resolve, reject) => {
          // Inject Vitally script
          var head = document.head || document.getElementsByTagName('head')[0]
          const script = document.createElement('script')
          script.async = true
          script.src = 'https://cdn.vitally.io/vitally.js/v1/vitally.js'

          head.appendChild(script)

          script.onload = resolve
          script.onerror = reject
        }).then(() => {
          const accountId = user.vitally?.account_id
          const accountName = user.vitally?.account_name
          // We need this information., otherwise Vitally won't work properly
          if (!accountId || !accountName) return
          // Init vitally script
          !function (n, t, r) { for (var i = n[t] = n[t] || [], o = function (r) { i[r] = i[r] || function () { for (var n = [], t = 0; t < arguments.length; t++)n[t] = arguments[t]; return i.push([r, n]) } }, u = 0, c = ["init", "user", "account", "track", "nps"]; u < c.length; u++){ o(c[u]) } }(window, "Vitally")
          Vitally.init(process.env.VUE_APP_VITALLY_KEY)
          // Define account (= organisation that pays for this user)
          Vitally.account({
            accountId: accountId, // A unique ID assigned by your codebase to each account (i.e. a database ID)
            traits: {
              name: accountName, // A 'name' trait is required
            }
          })
          // Define user
          Vitally.user({
            userId: user.user_id, // A unique ID assigned by your codebase to each user (i.e. a database ID)
            accountId: accountId, // Same account ID used in Vitally.account above - used to associate the user to the account
            traits: {
              name: user.full_name,
              email: user.email,
            }
          })
          // Define Survey
          Vitally.nps('survey', {
            productName: 'AcademicLabs',
            primaryColor: '#000000',
            delay: 300000,
            npsQuestion: ({ productName }) => `How likely are you to recommend ${productName} to someone you know?`,
            followUpTitle: ({ productName, score }) => {
              if (score <= 6) {
                return `Sorry to hear that!`
              } else if (score <= 8) {
                return `We would like to make it better!`
              }
              return `Glad to hear!`
            },
            followUpSubtitle: ({ productName, score }) => {
              return score <= 6 ? `What is the one thing we can do to make ${productName} better for you?` : `If we could add ANY new feature or data - what should we do to WOW you?`
            }
          })
        })
      }
    }
  },
  typekit (TypekitId) {
    let url = `https://use.typekit.net/${TypekitId}.js`

    return new Promise((resolve, reject) => {
      return this.loadScriptTypekit(url).then(() => {
        resolve()
      }).catch(() => {
        Sentry.captureMessage(new Error('[typekit] It\'s not possible to load Typekit script'))
      })
    }).then(() => {
      /* eslint-disable */
      try { Typekit.load({ async: true }) } catch (e) {}
    })
  },
  loadScriptTypekit (url) {
    return new Promise((resolve, reject) => {
      var head = document.head || document.getElementsByTagName('head')[0]
      const script = document.createElement('script')
      script.async = true
      script.src = url
      script.charset = 'utf8'

      head.appendChild(script)

      script.onload = resolve
      script.onerror = reject
    })
  },
  initSciteAi () {
    return new Promise((resolve, reject) => {
      var head = document.head || document.getElementsByTagName('head')[0]
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://cdn.scite.ai/badge/scite-badge-latest.min.js'

      head.appendChild(script)

      script.onload = resolve
      script.onerror = reject
    })
  }
}
